import React from 'react';
import PropTypes from 'prop-types';
import {
  CTASingleCard
} from '@comicrelief/component-library';
import { getImage } from 'gatsby-plugin-image';

import renderRichText from '../RichText/RichText';
import isInternalUrl from '../../utils/isInternalUrl';
import { paddingOptionMapping } from '../../utils/optionMapping';
import ImagePropType from '../../commonPropTypes/commonPropTypes';

const CTASingleCardWrapper = ({ data }) => {
  const {
    id,
    contentfulId,
    label,
    image,
    backgroundColour,
    ctaLink,
    ctaLabel,
    body: cardBody,
    paddingAbove,
    paddingBelow
  } = data;

  const cardId = id || contentfulId;

  if (!cardId) {
    return null;
  }
  const thisImageData = getImage(image);
  const thisImageFallback = thisImageData?.images?.fallback?.src;
  const thisImageLow = thisImageData?.placeholder?.fallback;
  const thisImageSrcSet = thisImageData?.images?.sources[0]?.srcSet;
  const thisImageDesc = image?.description ?? '';

  const isInternalLink = ctaLink ? isInternalUrl(ctaLink) : false;
  const target = isInternalLink ? 'self' : 'blank';
  const external = target === 'blank' ? 'noopener' : null;

  const renderedBody = cardBody ? renderRichText(cardBody, 'white', 'card') : null;

  // Contentful provides padding options as labels (e.g. "0px (0rem)"),
  const mapPaddingValue = value => paddingOptionMapping[value] || value;

  const processedPaddingAbove = paddingAbove ? mapPaddingValue(paddingAbove) : '2rem';
  const processedPaddingBelow = paddingBelow ? mapPaddingValue(paddingBelow) : '2rem';

  const card = {
    id: cardId,
    label,
    body: renderedBody,
    image,
    link: ctaLink || '',
    linkLabel: ctaLabel,
    fallback: thisImageFallback,
    imageLow: thisImageLow,
    images: thisImageSrcSet,
    description: thisImageDesc,
    target,
    external
  };

  return (
    <CTASingleCard
      data={{
        card,
        backgroundColour,
        paddingAbove: processedPaddingAbove,
        paddingBelow: processedPaddingBelow
      }}
    />
  );
};

CTASingleCardWrapper.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    contentfulId: PropTypes.string,
    label: PropTypes.string.isRequired,
    ctaLabel: PropTypes.string,
    ctaLink: PropTypes.string,
    body: PropTypes.shape({
      raw: PropTypes.string
    }),
    image: ImagePropType,
    backgroundColour: PropTypes.string,
    paddingAbove: PropTypes.string,
    paddingBelow: PropTypes.string
  }).isRequired
};

export default CTASingleCardWrapper;
